module.exports = __webpack_public_path__ + "static/media/life-tutorial-download-phone.e9686e15.jpg";